import * as actions from './tpaDynamicPagesActions';
import * as selectors from './tpaDynamicPagesSelectors';
import * as reducer from './tpaDynamicPagesReducer';

export { actions, reducer, selectors };
